export class  QueryRealtimeParamsModel {
	// fields
	items: any[];


	constructor(_items: any[] = []) {
		this.items = _items;
	}
}
